import React from "react";
import {
    Dialog, DialogTitle, DialogContent, DialogActions,
    Box, Typography, Avatar, IconButton, Button, Chip, Divider,
} from "@mui/material";
import ConfirmationNumberIcon from "@mui/icons-material/ConfirmationNumber";
import EditIcon from "@mui/icons-material/Edit";
import CloseIcon from "@mui/icons-material/Close";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";

import { SECTION_COLORS } from "../../../constants";
import StatusChip from "../../shared/StatusChip";

const InfoRow = ({ label, value }) => (
    <Box display="flex" alignItems="flex-start" gap={1} py={0.75}>
        <Typography fontSize={12} color="text.secondary" fontWeight={600} minWidth={120} fontFamily="Montserrat, sans-serif">
            {label}
        </Typography>
        <Typography fontSize={13} color="#1a1a2e" fontFamily="Montserrat, sans-serif" sx={{ wordBreak: "break-all" }}>
            {value ?? <em style={{ color: "#94a3b8" }}>—</em>}
        </Typography>
    </Box>
);

const ViewCouponTypeDialog = ({ open, couponType, onClose, onEditRequest }) => {
    if (!couponType) return null;

    const createdAt = couponType.created_at
        ? new Date(couponType.created_at).toLocaleDateString("fr-FR", { day: "2-digit", month: "long", year: "numeric" })
        : null;

    return (
        <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth
            PaperProps={{ sx: { borderRadius: 3 } }}>
            <DialogTitle sx={{ borderBottom: "2px solid #f1f3f5", px: 3, py: 2, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <Box display="flex" alignItems="center" gap={1}>
                    <Avatar sx={{ width: 32, height: 32, background: SECTION_COLORS.rewards.gradient }}>
                        <ConfirmationNumberIcon sx={{ fontSize: 18 }} />
                    </Avatar>
                    <Box>
                        <Typography variant="h6" fontFamily="Montserrat, sans-serif" fontWeight={700} color="#1a1a2e" fontSize={16}>
                            {couponType.name}
                        </Typography>
                        <Typography fontSize={11} color="text.secondary">Type de Coupon</Typography>
                    </Box>
                </Box>
                <Box display="flex" alignItems="center" gap={0.5}>
                    <IconButton size="small" onClick={() => { onClose(); onEditRequest(couponType); }}
                        sx={{ color: SECTION_COLORS.rewards.main, bgcolor: `${SECTION_COLORS.rewards.main}10` }}>
                        <EditIcon fontSize="small" />
                    </IconButton>
                    <IconButton onClick={onClose} size="small"><CloseIcon /></IconButton>
                </Box>
            </DialogTitle>

            <DialogContent sx={{ pt: "20px !important", px: 3, pb: 2 }}>
                <Box mb={1.5}>
                    <StatusChip active={couponType.active} />
                </Box>
                <Divider sx={{ mb: 2 }} />
                <InfoRow label="ID" value={couponType.id} />
                <InfoRow label="Nom" value={couponType.name} />
                <InfoRow label="Description" value={couponType.description} />
                <InfoRow label="Validité" value={couponType.validity_days ? `${couponType.validity_days} jours` : "Illimitée"} />
                <InfoRow label="Marque" value={couponType.brand} />
                {createdAt && (
                    <Box display="flex" alignItems="center" gap={0.5} mt={1}>
                        <CalendarTodayIcon sx={{ fontSize: 12, color: "#94a3b8" }} />
                        <Typography fontSize={11} color="#94a3b8">Créé le {createdAt}</Typography>
                    </Box>
                )}
            </DialogContent>

            <DialogActions sx={{ px: 3, py: 2, borderTop: "1px solid #f0f0f0" }}>
                <Button onClick={onClose} sx={{ textTransform: "none", color: "text.secondary" }}>Fermer</Button>
            </DialogActions>
        </Dialog>
    );
};

export default ViewCouponTypeDialog;
